import { createRouter, createWebHashHistory } from "vue-router";
import Icon from "@/components/common/Icon.vue";
import Separator from "@/components/common/Separator.vue";
import CloseButton from "@/components/common/buttons/CloseButton.vue";
import ActionButton from "@/components/common/buttons/ActionButton.vue";
import ButtonBar from "@/components/common/buttons/ButtonBar.vue";
import TextField from "@/components/common/forms/TextField.vue";
import NumberField from "@/components/common/forms/NumberField.vue";
import PasswordField from "@/components/common/forms/PasswordField.vue";
import CheckBox from "@/components/common/forms/CheckBox.vue";
import SwitchField from "@/components/common/forms/SwitchField.vue";
import DropDown from "@/components/common/forms/DropDown.vue";
import RadioButton from "@/components/common/forms/RadioButton.vue";
import ValidationError from "@/components/common/forms/ValidationError.vue";
import FormButtons from "@/components/common/forms/FormButtons.vue";
import Layout from "@/views/Layout.vue";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import global from "./global";
import routes from "./routes"
import store from "./store";
import App from "./App.vue";
import * as filters from "./filters/all";
import * as globalMixins from "./mixins";

export default {
    install: (app) => {
        app.use(FloatingVue);

        Object.values(globalMixins).forEach(mixin => {
            app.mixin(mixin);
        });

        app.config.globalProperties.$filters = filters.dateFilters;
        app.component("Icon", Icon);
        app.component("Separator", Separator);
        app.component("CloseButton", CloseButton);
        app.component("ActionButton", ActionButton);
        app.component("ButtonBar", ButtonBar);
        app.component("TextField", TextField);
        app.component("NumberField", NumberField);
        app.component("PasswordField", PasswordField);
        app.component("CheckBox", CheckBox);
        app.component("SwitchField", SwitchField);
        app.component("DropDown", DropDown);
        app.component("RadioButton", RadioButton);
        app.component("ValidationError", ValidationError);
        app.component("FormButtons", FormButtons);
        app.component("Layout", Layout);

        // Use hash history - required for OAuth redirects which use hash-based URLs
        // (e.g., /#/oAuthReply?code=xxx)
        const router = createRouter({
            history: createWebHashHistory(),
            routes
        });

        app.use(router);
        global.setRouter(router);

        const storeInstance = store.create();
        app.use(storeInstance);
        global.setStore(storeInstance);
    },
    App,
    Router: global.getRouter,
    Store: global.getStore
};